import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PortConnections from '../Assembly/PortConnections'
import components from '../concept/data' // component details
import animationStyle from './loginAnimation.module.css'

import {
    getAppName,
    getLogo,
    getBrand,
    getLegalInfo,
    getSplashConfig,
} from '../../hooks/useBrandConfig'

const SplashScreen = (props) => {
    useEffect(() => {
        // Initializing the workspace state exactly as it was in your original file
        const concept = { counter: [], componentProps: {} }
        const assembly = {
            components: components,
            PortConnections: PortConnections,
            workspace: {
                bibox: { top: 208, left: 328 },
                components: {},
                offset: { top: 0, left: 0 },
                scale: 1,
            },
            height: document.body.clientHeight,
            width: document.body.clientWidth,
        }
        const logic = {
            program: [
                {
                    type: 'start',
                    state: {
                        bic1: false,
                        bic2: false,
                        bic3: false,
                        bid2: false,
                        bif1: false,
                        bif2: false,
                        bif3: false,
                    },
                    bic1: false,
                    bic2: false,
                    bic3: false,
                    bid1: false,
                    bid2: false,
                    bif1: false,
                    bif2: false,
                    bif3: false,
                    bid3: false,
                    bmp3: false,
                },
            ],
            end: { type: 'end', state: 'repeat' },
            insertState: false,
            offset: { left: 0, top: 0 },
            scale: 1,
            currentProgramGuide: 0,
            active: [-1, -1],
            bottomPanel: 'border',
        }

        // Dispatch initial workspace settings to Redux
        props.clearComponent()
        props.selecteComponent(concept)
        props.assemblyComponent(assembly)
        props.logicComponent(logic)

        // The CSS animation takes 3.5 seconds (1.5s delay + 2s duration)
        // Redirecting at 3.8 seconds ensures a smooth transition right after it finishes.
        const redirectTimer = setTimeout(() => {
            props.history.push('/kitSelection')
        }, 3800)

        // Cleanup timer on unmount
        return () => clearTimeout(redirectTimer)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const slideDirection = sessionStorage.getItem('slideDirection')

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#4A1FCC',
            }}
            className={`${slideDirection === 'true' ? 'slide-right' : ''}`}
        >
            {/* Splash screen bursting/expanding circle animation */}
            <div
                className={animationStyle.newMainSec}
                style={{
                    backgroundColor: `${getSplashConfig().background_color}`,
                }}
            >
                <p
                    className={animationStyle.newMainSecText}
                    style={{ color: `${getSplashConfig().text_color}` }}
                >
                    {getBrand().splash.text}
                </p>
            </div>

            <div className={animationStyle.manpage}>
                <div
                    className={animationStyle.iconDiv}
                    style={{
                        backgroundColor: `${getSplashConfig().background_color}`,
                    }}
                >
                    <img
                        className={animationStyle.iconImage}
                        src={getLogo('compact')}
                        alt="app logo"
                    />
                </div>

                <p className={animationStyle.iconText}>{getAppName()}</p>

                {/* Copyright info */}
                <div className={animationStyle.bottomTextDiv}>
                    <p className={animationStyle.copyRightText}>
                        <span style={{ fontSize: '1.6rem' }}>&copy;</span>
                        {'  '}
                        {getLegalInfo().copyright_text}
                    </p>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        selecteComponent: (data) => {
            dispatch({ type: 'COMPONENT', payload: data })
        },
        assemblyComponent: (data) => {
            dispatch({ type: 'ASSEMBLY', payload: data })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_RESET', payload: data })
        },
        clearComponent: () => {
            dispatch({ type: 'CLEAR_COMPONENT_SELECTION' })
        },
    }
}

export default withRouter(connect(null, mapDispatchToProps)(SplashScreen))
